import * as React from 'react';
import { cn } from '@/lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  children?: React.ReactNode;
}

function Skeleton({
  className,
  loading = true,
  children,
  ...props
}: SkeletonProps) {
  if (!loading && children) {
    return <>{children}</>;
  }

  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
